import React from "react";

const NumberedInstructionStep = ({ number, children }) => (
  <li className="tw-flex tw-items-start tw-gap-3">
    <span
      className="tw-flex tw-h-[30px] tw-w-[30px] tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-dis-sky tw-text-sm tw-font-bold tw-text-dis-navy"
      aria-hidden="true"
    >
      {number}
    </span>
    <span className="tw-pt-0.5 tw-text-dis-base tw-leading-[1.5] tw-text-dis-text-2">
      {children}
    </span>
  </li>
);

export default NumberedInstructionStep;
